import jsonStringfy from 'fast-json-stable-stringify';
export function encodeObject(obj) {
  return btoa(jsonStringfy(obj));
}